<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>

    <v-app id="inspire" light>
      <v-card color="grey lighten-4" flat>
        <v-layout row wrap>
          <v-flex xs12 md12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title>{{$t('Comparative-Customer-Report')}}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn color="pink lighten-1" dark @click="openMailDialog" small>
  <v-icon left>email</v-icon> {{ $t('Send-Mail') }}
</v-btn>
              <v-menu bottom="" left>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>

                  <v-list-tile @click="getListHtml()">
                    <v-list-tile-title>Html {{ $t('Download') }}</v-list-tile-title>
                  </v-list-tile>


                  <!-- <v-list-tile @click="getListExcel()">
                    <v-list-tile-title>Excel {{ $t('Download') }}</v-list-tile-title>
                  </v-list-tile> -->

                </v-list>
              </v-menu>
            </v-toolbar>
          </v-flex>

<v-dialog v-model="mailDialog" persistent max-width="640px" scrollable>
  <v-card>
    <v-toolbar dense flat color="info" dark>
      <v-toolbar-title>{{ $t('Send-Mail') }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="closeMailDialog"><v-icon>close</v-icon></v-btn>
    </v-toolbar>

    <v-card-text>
      <v-form ref="mailForm" v-model="mailValid" lazy-validation>
        <v-layout wrap>
          <v-flex xs12>
            <v-text-field
              v-model="mailPayload.To"
              :label="$t('Recipient-Email')"
              :rules="[rules.required, rules.email]"
              clearable
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm6>
            <v-text-field
              v-model="mailPayload.AgencyName"
              :label="$t('Agency-Name')"
              :rules="[rules.required]"
              clearable
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm6>
            <v-text-field
              v-model="mailPayload.DocType"
              :label="$t('Document-Type')"
              :rules="[rules.required]"
              :disabled="true"
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm6>
            <v-text-field
              v-model="mailPayload.AgentFullName"
              :label="$t('Agent-Full-Name')"
              :rules="[rules.required]"
              clearable
            ></v-text-field>
          </v-flex>

          <v-flex xs12>
            <v-textarea
              v-model="mailPayload.CustomBody"
              :label="$t('Message')"
              :rules="[rules.required]"
              auto-grow
              rows="3"
            ></v-textarea>
          </v-flex>
        </v-layout>
      </v-form>
    </v-card-text>

    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn flat @click="closeMailDialog">{{ $t('Cancel') }}</v-btn>
      <v-btn
        color="info"
        :loading="mailLoading"
        :disabled="!mailValid || mailLoading"
        @click="sendMail"
      >
        <v-icon left>send</v-icon>{{ $t('Send') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
          <v-container fluid>

            <v-form ref="formgunluksatis" v-model="valid" lazy-validation>
              <v-layout row wrap>

                <v-flex pb-3 xs12 sm12 md12>
                  <v-card flat>

                    <v-layout row wrap>
                      <v-flex xs12 sm6 pt-2 md2>
                        <tarihcomp :etiket="$t('Current-Period-Starting-Date')" :detaygizle="false"
                          :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'year'"
                          v-bind:value="Rapor.BaslangicDonem" v-model="Rapor.BaslangicDonem"></tarihcomp>
                      </v-flex>

                      <v-flex xs12 pt-2 sm6 md2>
                        <tarihcomp :etiket="$t('Current-Period-Ending-Date')" :detaygizle="false"
                          :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'"
                          v-bind:value="Rapor.BitisDonem" v-model="Rapor.BitisDonem"></tarihcomp>
                      </v-flex>

                      <v-flex xs12 sm6 pt-2 md2>
                        <tarihcomp :etiket="$t('Period-Starting-Date-Compared')" :detaygizle="false"
                          :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'lastyear'"
                          v-bind:value="Rapor.BaslangicOncekiDonem" v-model="Rapor.BaslangicOncekiDonem"></tarihcomp>
                      </v-flex>

                      <v-flex xs12 pt-2 sm6 md2>
                        <tarihcomp :etiket="$t('Period-Ending-Date-Compared')" :detaygizle="false"
                          :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'lastyeartoday'"
                          v-bind:value="Rapor.BitisOncekiDonem" v-model="Rapor.BitisOncekiDonem"></tarihcomp>
                      </v-flex>

                      <v-flex pt-2>
                        <v-layout align-center="" fill-height="">
                          <div v-if="load1">
                            <v-btn color="info" @click="getList()" fab small="" dark>
                              <v-icon>search</v-icon>
                            </v-btn>
                          </div>
                          <div v-if="progress">
                            <v-layout>
                              <v-progress-circular indeterminate :width="4" color="blue"></v-progress-circular>
                            </v-layout>
                          </div>
                          <v-badge color="white" :overlap="true">
                            <template v-slot:badge>
                              <v-icon v-if="filtrevarmi" large color="green">
                                check_circle_outline </v-icon>
                            </template>

                            <v-btn small="" @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab"
                              @click="filtrele()" color="info" fab dark>
                              <v-icon>filter_list</v-icon>
                            </v-btn>
                            <v-tooltip bottom="" :activator="el" v-model="tooltip">
                              <span>{{$t('Add-Search-Filter')}}</span>
                            </v-tooltip>



                          </v-badge>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                    <v-layout pt-2 row wrap>
                      <v-flex xs12 sm6 md6 pl-1>
                        <v-flex xs12 sm12 md12>
                          <v-card flat class="black--text">
                            <v-card flat="">
                              <v-card-actions>
                                <v-layout row wrap>
                                  <v-flex xs12 sm12 md12>
                                    <v-layout align-center="" justify-start="" fill-height="">
                                      <span class="subheading black--text font-weight-bold"> {{$t('Current-Period-Grand-Total')}}
                                      </span>
                                    </v-layout>
                                  </v-flex>

                                  <v-flex xs12 sm12 md12>
                                    <v-card flat class="black--text">
                                      <v-layout>

                                        <v-flex xs3 sm3 md3>
                                          <v-layout align-center="" justify-center="" fill-height="">
                                            <span class="body-1 font-weight-">
                                            </span>
                                          </v-layout>
                                        </v-flex>

                                        <v-flex xs3 sm3 md3>
                                          <v-layout align-center="" justify-end="" fill-height="">
                                            <span class="body-1 font-weight-">
                                              {{$t('Domestic-Line')}}
                                            </span>
                                          </v-layout>
                                        </v-flex>

                                        <v-flex xs3 sm3 md3>
                                          <v-layout align-center="" justify-end="" fill-height="">
                                            <span class="body-1 font-weight-">
                                              {{ $t('International-Line') }}
                                            </span>
                                          </v-layout>
                                        </v-flex>

                                        <v-flex xs3 sm3 md3>
                                          <v-layout align-center="" justify-end="" fill-height="">
                                            <span class="body-1 font-weight-">
                                              {{$t('Total')}}
                                            </span>
                                          </v-layout>
                                        </v-flex>

                                      </v-layout>

                                      <v-divider light></v-divider>
                                      <v-layout>
                                        <v-flex xs3 sm3 md3>
                                          <v-layout align-center="" justify-start="" fill-height="">
                                            <span class="caption font-weight-thin">
                                              {{$t('Number')}}
                                            </span>
                                          </v-layout>
                                        </v-flex>
                                        <v-flex xs3 sm3 md3>
                                          <v-layout align-center="" justify-end="" fill-height="">
                                            <span class="caption font-weight-thin">
                                              {{DonemToplam.IcHatAdet}} </span>
                                          </v-layout>
                                        </v-flex>
                                        <v-flex xs3 sm3 md3>
                                          <v-layout align-center="" justify-end="" fill-height="">
                                            <span class="caption font-weight-thin">
                                              {{DonemToplam.DisHatAdet}}</span>
                                          </v-layout>
                                        </v-flex>
                                        <v-flex xs3 sm3 md3>
                                          <v-layout align-center="" justify-end="" fill-height="">
                                            <span class="caption font-weight-thin">
                                              {{DonemToplam.ToplamAdet}}</span>
                                          </v-layout>
                                        </v-flex>
                                      </v-layout>

                                      <v-divider light></v-divider>
                                      <v-layout>
                                        <v-flex xs3 sm3 md3>
                                          <v-layout align-center="" justify-start="" fill-height="">
                                            <span class="caption font-weight-thin">
                                              {{ $t('Received-Amounts') }}
                                            </span>
                                          </v-layout>
                                        </v-flex>
                                        <v-flex xs3 sm3 md3>
                                          <v-layout align-center="" justify-end="" fill-height="">
                                            <span class="caption font-weight-thin">
                                              {{DonemToplam.IcHatGelirTutar | moneyformat}}{{getparabirimi()}}</span>
                                          </v-layout>
                                        </v-flex>
                                        <v-flex xs3 sm3 md3>
                                          <v-layout align-center="" justify-end="" fill-height="">
                                            <span class="caption font-weight-thin">
                                              {{DonemToplam.DisHatGelirTutar | moneyformat}}{{getparabirimi()}} </span>
                                          </v-layout>
                                        </v-flex>
                                        <v-flex xs3 sm3 md3>
                                          <v-layout align-center="" justify-end="" fill-height="">
                                            <span class="caption font-weight-thin">
                                              {{DonemToplam.ToplamGelirTutar | moneyformat}}{{getparabirimi()}} </span>
                                          </v-layout>
                                        </v-flex>
                                      </v-layout>

                                      <v-divider light></v-divider>
                                      <v-layout>
                                        <v-flex xs3 sm3 md3>
                                          <v-layout align-center="" justify-start="" fill-height="">
                                            <span class="caption font-weight-thin">
                                              {{ $t('Revenue-Amounts') }}
                                            </span>
                                          </v-layout>
                                        </v-flex>
                                        <v-flex xs3 sm3 md3>
                                          <v-layout align-center="" justify-end="" fill-height="">
                                            <span class="caption font-weight-thin">
                                              {{DonemToplam.IcHatCiroTutar | moneyformat}}{{getparabirimi()}} </span>
                                          </v-layout>
                                        </v-flex>
                                        <v-flex xs3 sm3 md3>
                                          <v-layout align-center="" justify-end="" fill-height="">
                                            <span class="caption font-weight-thin">
                                              {{DonemToplam.DisHatCiroTutar | moneyformat}}{{getparabirimi()}} </span>
                                          </v-layout>
                                        </v-flex>
                                        <v-flex xs3 sm3 md3>
                                          <v-layout align-center="" justify-end="" fill-height="">
                                            <span class="caption font-weight-thin">
                                              {{DonemToplam.ToplamCiroTutar | moneyformat}}{{getparabirimi()}} </span>
                                          </v-layout>
                                        </v-flex>
                                      </v-layout>

                                      <v-divider light></v-divider>
                                      <v-layout>
                                        <v-flex xs3 sm3 md3>
                                          <v-layout align-center="" justify-start="" fill-height="">
                                            <span class="caption font-weight-thin">
                                              {{ $t('Share') }}
                                            </span>
                                          </v-layout>
                                        </v-flex>
                                        <v-flex xs3 sm3 md3>
                                          <v-layout align-center="" justify-end="" fill-height="">
                                            <span class="caption font-weight-thin">
                                            </span>
                                          </v-layout>
                                        </v-flex>
                                        <v-flex xs3 sm3 md3>
                                          <v-layout align-center="" justify-end="" fill-height="">
                                            <span class="caption font-weight-thin">
                                            </span>
                                          </v-layout>
                                        </v-flex>
                                        <v-flex xs3 sm3 md3>
                                          <v-layout align-center="" justify-end="" fill-height="">
                                            <span class="caption font-weight-thin">
                                              {{DonemToplam.Pay | moneyformat}}{{getparabirimi()}} </span>
                                          </v-layout>
                                        </v-flex>
                                      </v-layout>
                                    </v-card>
                                  </v-flex>


                                </v-layout>
                              </v-card-actions>
                            </v-card>
                          </v-card>
                        </v-flex>


                      </v-flex>

                      <v-flex xs12 sm6 md6 pr-1>
                        <v-flex xs12 sm12 md12>
                          <v-card flat class="black--text">
                            <v-card flat="">
                              <v-card-actions>
                                <v-layout row wrap>
                                  <v-flex xs12 sm12 md12>
                                    <v-layout align-center="" justify-start="" fill-height="">
                                      <span class="subheading black--text font-weight-bold"> {{$t('Prior-Period-Grand-Total')}}
                                      </span>
                                    </v-layout>
                                  </v-flex>

                                  <v-flex xs12 sm12 md12>
                                    <v-card flat class="black--text">
                                      <v-layout>
                                        <v-flex xs3 sm3 md3>
                                          <v-layout align-center="" justify-center="" fill-height="">
                                            <span class="body-1 font-weight-">
                                            </span>
                                          </v-layout>
                                        </v-flex>
                                        <v-flex xs3 sm3 md3>
                                          <v-layout align-center="" justify-end="" fill-height="">
                                            <span class="body-1 font-weight-">
                                              {{$t('Domestic-Line')}}
                                            </span>
                                          </v-layout>
                                        </v-flex>
                                        <v-flex xs3 sm3 md3>
                                          <v-layout align-center="" justify-end="" fill-height="">
                                            <span class="body-1 font-weight-">
                                              {{ $t('International-Line') }}
                                            </span>
                                          </v-layout>
                                        </v-flex>

                                        <v-flex xs3 sm3 md3>
                                          <v-layout align-center="" justify-end="" fill-height="">
                                            <span class="body-1 font-weight-">
                                              {{$t('Total')}}
                                            </span>
                                          </v-layout>
                                        </v-flex>

                                      </v-layout>

                                      <v-divider light></v-divider>
                                      <v-layout>
                                        <v-flex xs3 sm3 md3>
                                          <v-layout align-center="" justify-start="" fill-height="">
                                            <span class="caption font-weight-thin">
                                              {{$t('Number')}}
                                            </span>
                                          </v-layout>
                                        </v-flex>
                                        <v-flex xs3 sm3 md3>
                                          <v-layout align-center="" justify-end="" fill-height="">
                                            <span class="caption font-weight-thin">
                                              {{ODonemToplam.IcHatAdet}} </span>
                                          </v-layout>
                                        </v-flex>
                                        <v-flex xs3 sm3 md3>
                                          <v-layout align-center="" justify-end="" fill-height="">
                                            <span class="caption font-weight-thin">
                                              {{ODonemToplam.DisHatAdet}}</span>
                                          </v-layout>
                                        </v-flex>
                                        <v-flex xs3 sm3 md3>
                                          <v-layout align-center="" justify-end="" fill-height="">
                                            <span class="caption font-weight-thin">
                                              {{ODonemToplam.ToplamAdet}}</span>
                                          </v-layout>
                                        </v-flex>
                                      </v-layout>

                                      <v-divider light></v-divider>
                                      <v-layout>
                                        <v-flex xs3 sm3 md3>
                                          <v-layout align-center="" justify-start="" fill-height="">
                                            <span class="caption font-weight-thin">
                                              {{ $t('Received-Amounts') }}
                                            </span>
                                          </v-layout>
                                        </v-flex>
                                        <v-flex xs3 sm3 md3>
                                          <v-layout align-center="" justify-end="" fill-height="">
                                            <span class="caption font-weight-thin">
                                              {{ODonemToplam.IcHatGelirTutar | moneyformat}}{{getparabirimi()}}</span>
                                          </v-layout>
                                        </v-flex>
                                        <v-flex xs3 sm3 md3>
                                          <v-layout align-center="" justify-end="" fill-height="">
                                            <span class="caption font-weight-thin">
                                              {{ODonemToplam.DisHatGelirTutar | moneyformat}}{{getparabirimi()}} </span>
                                          </v-layout>
                                        </v-flex>
                                        <v-flex xs3 sm3 md3>
                                          <v-layout align-center="" justify-end="" fill-height="">
                                            <span class="caption font-weight-thin">
                                              {{ODonemToplam.ToplamGelirTutar | moneyformat}}{{getparabirimi()}} </span>
                                          </v-layout>
                                        </v-flex>
                                      </v-layout>

                                      <v-divider light></v-divider>
                                      <v-layout>
                                        <v-flex xs3 sm3 md3>
                                          <v-layout align-center="" justify-start="" fill-height="">
                                            <span class="caption font-weight-thin">
                                              {{ $t('Revenue-Amounts') }}
                                            </span>
                                          </v-layout>
                                        </v-flex>
                                        <v-flex xs3 sm3 md3>
                                          <v-layout align-center="" justify-end="" fill-height="">
                                            <span class="caption font-weight-thin">
                                              {{ODonemToplam.IcHatCiroTutar | moneyformat}}{{getparabirimi()}} </span>
                                          </v-layout>
                                        </v-flex>
                                        <v-flex xs3 sm3 md3>
                                          <v-layout align-center="" justify-end="" fill-height="">
                                            <span class="caption font-weight-thin">
                                              {{ODonemToplam.DisHatCiroTutar | moneyformat}}{{getparabirimi()}} </span>
                                          </v-layout>
                                        </v-flex>
                                        <v-flex xs3 sm3 md3>
                                          <v-layout align-center="" justify-end="" fill-height="">
                                            <span class="caption font-weight-thin">
                                              {{ODonemToplam.ToplamCiroTutar | moneyformat}}{{getparabirimi()}} </span>
                                          </v-layout>
                                        </v-flex>
                                      </v-layout>

                                      <v-divider light></v-divider>
                                      <v-layout>
                                        <v-flex xs3 sm3 md3>
                                          <v-layout align-center="" justify-start="" fill-height="">
                                            <span class="caption font-weight-thin">
                                              {{ $t('Share') }}
                                            </span>
                                          </v-layout>
                                        </v-flex>
                                        <v-flex xs3 sm3 md3>
                                          <v-layout align-center="" justify-end="" fill-height="">
                                            <span class="caption font-weight-thin">
                                            </span>
                                          </v-layout>
                                        </v-flex>
                                        <v-flex xs3 sm3 md3>
                                          <v-layout align-center="" justify-end="" fill-height="">
                                            <span class="caption font-weight-thin">
                                            </span>
                                          </v-layout>
                                        </v-flex>
                                        <v-flex xs3 sm3 md3>
                                          <v-layout align-center="" justify-end="" fill-height="">
                                            <span class="caption font-weight-thin">
                                              {{ODonemToplam.Pay | moneyformat}}{{getparabirimi()}} </span>
                                          </v-layout>
                                        </v-flex>
                                      </v-layout>
                                    </v-card>
                                  </v-flex>


                                </v-layout>
                              </v-card-actions>
                            </v-card>
                          </v-card>
                        </v-flex>
                      </v-flex>



                    </v-layout>
                    <v-layout row wrap>
                    </v-layout>
                  </v-card>
                </v-flex>
                <v-flex xs12 sm12 md12 pb-3>
                  <ReportTable
                    :headers="comparativeReportHeaders"
                    :items="comparativeReportItems"
                    storage-key="mukayeselirapor_columns"
                    :loading="progress"
                    :has-searched="reportHasSearched"
                    :show-search="true"
                    :search-label="$t('Search')"
                    :show-frontend-export="true"
                    :export-title="$t('Comparative-Customer-Report')"
                    :export-meta-items="comparativeExportMetaItems"
                    :export-summary-cards="comparativeSummaryCards"
                    :rows-per-page-items="[20, 50, 100, 200, 500, 1000]"
                  ></ReportTable>
                </v-flex>

                <v-layout row wrap align-center="">
                  <v-flex sm12 md3 xs3>
                    <v-btn-toggle v-if="itemssatis.length>0" v-model="listtype">
                      <v-btn large color="info" text value="0">
                        <span>{{ $t('View-List') }}</span>
                        <v-icon>format_list_bulleted</v-icon>
                      </v-btn>
                      <v-btn large color="info" text value="1">
                        <span>{{ $t('View-Graphic') }} </span>
                        <v-icon>bar_chart</v-icon>
                      </v-btn>
                    </v-btn-toggle>
                  </v-flex>
                  <v-flex sm12 md9 xs9>
                    <v-layout v-if="itemssatis.length>0 " justify-start="" align-center="">
                      <span class="subheading grey--text font-weight-bold"> 
                        {{this.itemssatisview.length}} / {{this.itemssatis.length}} </span>
                    </v-layout>
                  </v-flex>
                </v-layout>



                <v-flex pb-3 v-for="item in itemssatis" v-show="listtype=='0'" v-bind:key="item.id" xs12 sm12 md12>
                  <v-hover>
                    <v-card flat="" slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`" class="mx-auto"
                      width="100%">
                      <v-card-title>
                        <v-layout row wrap>
                          <v-flex xs12 sm12 md12>
                            <v-card flat class="white--text">
                              <v-card flat="">
                                <v-card-actions>
                                  <v-layout row wrap>

                                    <!-- <v-flex xs12 sm12>
                            <v-card flat>
                              <v-data-table :headers="headerssatis" :rows-per-page-items=[50,100,200]
                                :items="itemssatis" :search="searchsatilanbilet">
                                <template slot="items" slot-scope="props">
                                  <td class="text-xs-left">{{ props.item.Cari.Kod }}</td>
                                  <td class="text-xs-left">{{ props.item.Cari.Unvan }}</td>
                                  <td class="text-xs-right">{{ props.item.OncekiDonemBilgi.IcHatAdet  }}</td>
                                  <td class="text-xs-right">{{ props.item.OncekiDonemBilgi.DisHatAdet}}</td>
                                  <td class="text-xs-right">{{ props.item.OncekiDonemBilgi.ToplamAdet}}</td>
                                  <td class="text-xs-right">
                                    {{ props.item.OncekiDonemBilgi.IcHatGelirTutar | moneyformat}}</td>
                                  <td class="text-xs-right">
                                    {{ props.item.OncekiDonemBilgi.DisHatGelirTutar | moneyformat}}</td>
                                  <td class="text-xs-right">
                                    {{ props.item.OncekiDonemBilgi.ToplamGelirTutar | moneyformat}}</td>
                                  <td class="text-xs-right">
                                    {{ props.item.OncekiDonemBilgi.IcHatCiroTutar | moneyformat}}</td>
                                  <td class="text-xs-right">
                                    {{ props.item.OncekiDonemBilgi.DisHatCiroTutar | moneyformat}}</td>
                                  <td class="text-xs-right">
                                    {{ props.item.OncekiDonemBilgi.ToplamCiroTutar | moneyformat}}</td>
                                  <td class="text-xs-right">{{ props.item.OncekiDonemBilgi.Pay | moneyformat}}</td>
                                  <td class="text-xs-right">{{ props.item.DonemBilgi.IcHatAdet  }}</td>
                                  <td class="text-xs-right">{{ props.item.DonemBilgi.DisHatAdet}}</td>
                                  <td class="text-xs-right">{{ props.item.DonemBilgi.ToplamAdet }}</td>
                                  <td class="text-xs-right">{{ props.item.DonemBilgi.IcHatGelirTutar | moneyformat}}
                                  </td>
                                  <td class="text-xs-right">{{ props.item.DonemBilgi.DisHatGelirTutar | moneyformat}}
                                  </td>
                                  <td class="text-xs-right">{{ props.item.DonemBilgi.ToplamGelirTutar | moneyformat}}
                                  </td>
                                  <td class="text-xs-right">{{ props.item.DonemBilgi.IcHatCiroTutar | moneyformat}}</td>
                                  <td class="text-xs-right">{{ props.item.DonemBilgi.DisHatCiroTutar | moneyformat}}
                                  </td>
                                  <td class="text-xs-right">{{ props.item.DonemBilgi.ToplamCiroTutar | moneyformat}}
                                  </td>
                                  <td class="text-xs-right">{{ props.item.DonemBilgi.Pay | moneyformat}}</td>
                                </template>
                                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                                    {{ $t('No-records-searched-for', { value: searchsatilanbilet}) }}
                                </v-alert>
                              </v-data-table>
                            </v-card>
                          </v-flex> -->

                                    <v-flex xs12 sm12 md12 pr-1>
                                      <v-flex xs12 sm12 md12>
                                        <v-card flat class="black--text">
                                          <v-card flat="">
                                            <v-card-actions>
                                              <v-layout row wrap>

                                                <v-flex xs12 sm12 md12>
                                                  <v-layout pl-3 align-center="" justify-start="" fill-height="">
                                                    <v-icon color="red">person</v-icon> &nbsp; <span
                                                      class="subheading black--text font-weight-"> {{item.Cari.Kod}} -
                                                      {{item.Cari.Unvan}}
                                                    </span> <span class="body-1 black--text font-weight-thin"> &nbsp;
                                                      (&nbsp; {{ $t('Share-Previous-Period') }} : %{{item.OncekiDonemBilgi.Pay}} - {{ $t('Period-Share') }}:
                                                      %{{item.DonemBilgi.Pay}})
                                                    </span>
                                                  </v-layout>
                                                </v-flex>

                                                <v-flex pl-2 pt-2 pr-2 xs12 sm6 md4>
                                                  <v-card flat class="black--text">
                                                    <v-divider light></v-divider>

                                                    <v-layout>
                                                      <v-flex xs3 sm3 md4>
                                                        <v-layout align-center="" justify-start="" fill-height="">
                                                          <span class="body-1 font-weight-thin">
                                                            {{ $t('Domestic-quantity') }}
                                                          </span>
                                                        </v-layout>
                                                      </v-flex>
                                                      <v-flex xs3 sm3 md5>
                                                        <v-layout align-center="" justify-end="" fill-height="">
                                                          <span class="body-1 font-weight-thin">
                                                            {{item.OncekiDonemBilgi.IcHatAdet}}
                                                            &nbsp;-&nbsp;{{item.DonemBilgi.IcHatAdet}}
                                                          </span>
                                                        </v-layout>
                                                      </v-flex>
                                                      <v-flex xs3 sm3 md2>
                                                        <v-layout align-center="" justify-center="" fill-height="">
                                                          <span class="caption font-weight-thin">
                                                            %
                                                            {{ ((item.DonemBilgi.IcHatAdet-item.OncekiDonemBilgi.IcHatAdet) /item.OncekiDonemBilgi.IcHatAdet) * 100 | yuzdekontrol }}
                                                          </span>
                                                        </v-layout>
                                                      </v-flex>
                                                      <v-flex xs3 sm3 md1>
                                                        <v-layout align-center="" justify-end="" fill-height="">
                                                          <span class="body-1 font-weight-thin">
                                                            <v-icon
                                                              v-if="item.OncekiDonemBilgi.IcHatAdet < item.DonemBilgi.IcHatAdet"
                                                              medium="" color="green">arrow_drop_up</v-icon>
                                                            <v-icon medium=""
                                                              v-if="item.OncekiDonemBilgi.IcHatAdet == item.DonemBilgi.IcHatAdet"
                                                              color="yellow">compare_arrows</v-icon>
                                                            <v-icon medium
                                                              v-if="item.OncekiDonemBilgi.IcHatAdet > item.DonemBilgi.IcHatAdet"
                                                              color="red">arrow_drop_down</v-icon>

                                                          </span>
                                                        </v-layout>
                                                      </v-flex>
                                                    </v-layout>

                                                    <v-divider light></v-divider>

                                                    <v-layout>
                                                      <v-flex xs3 sm3 md4>
                                                        <v-layout align-center="" justify-start="" fill-height="">
                                                          <span class="body-1 font-weight-thin">
                                                            {{ $t('International-Quantity') }}
                                                          </span>
                                                        </v-layout>
                                                      </v-flex>
                                                      <v-flex xs3 sm3 md5>
                                                        <v-layout align-center="" justify-end="" fill-height="">
                                                          <span class="body-1 font-weight-thin">
                                                            {{item.OncekiDonemBilgi.DisHatAdet}}
                                                            &nbsp;-&nbsp;{{item.DonemBilgi.DisHatAdet}}
                                                          </span>
                                                        </v-layout>
                                                      </v-flex>
                                                      <v-flex xs3 sm3 md2>
                                                        <v-layout align-center="" justify-center="" fill-height="">
                                                          <span class="caption font-weight-thin">

                                                            %{{ ((item.DonemBilgi.DisHatAdet-item.OncekiDonemBilgi.DisHatAdet) /item.OncekiDonemBilgi.DisHatAdet) * 100 | yuzdekontrol}}
                                                          </span>
                                                        </v-layout>
                                                      </v-flex>
                                                      <v-flex xs3 sm3 md1>
                                                        <v-layout align-center="" justify-end="" fill-height="">
                                                          <span class="body-1 font-weight-thin">
                                                            <v-icon
                                                              v-if="item.OncekiDonemBilgi.DisHatAdet < item.DonemBilgi.DisHatAdet"
                                                              medium="" color="green">arrow_drop_up</v-icon>
                                                            <v-icon medium=""
                                                              v-if="item.OncekiDonemBilgi.DisHatAdet == item.DonemBilgi.DisHatAdet"
                                                              color="yellow">compare_arrows</v-icon>
                                                            <v-icon medium
                                                              v-if="item.OncekiDonemBilgi.DisHatAdet > item.DonemBilgi.DisHatAdet"
                                                              color="red">arrow_drop_down</v-icon>
                                                          </span>
                                                        </v-layout>
                                                      </v-flex>
                                                    </v-layout>
                                                    <v-divider light></v-divider>
                                                    <v-layout>
                                                      <v-flex xs3 sm3 md4>
                                                        <v-layout align-center="" justify-start="" fill-height="">
                                                          <span class="body-1 font-weight-thin">
                                                            {{$t('totalnumber')}}
                                                          </span>
                                                        </v-layout>
                                                      </v-flex>
                                                      <v-flex xs3 sm3 md5>
                                                        <v-layout align-center="" justify-end="" fill-height="">
                                                          <span class="body-1 font-weight-thin">
                                                            {{item.OncekiDonemBilgi.ToplamAdet}}
                                                            &nbsp;-&nbsp;{{item.DonemBilgi.ToplamAdet}}
                                                          </span>
                                                        </v-layout>
                                                      </v-flex>
                                                      <v-flex xs3 sm3 md2>
                                                        <v-layout align-center="" justify-center="" fill-height="">
                                                          <span class="caption font-weight-thin">

                                                            %
                                                            {{ ((item.DonemBilgi.ToplamAdet-item.OncekiDonemBilgi.ToplamAdet) /item.OncekiDonemBilgi.ToplamAdet) * 100 | yuzdekontrol}}
                                                          </span>
                                                        </v-layout>
                                                      </v-flex>
                                                      <v-flex xs3 sm3 md1>
                                                        <v-layout align-center="" justify-end="" fill-height="">
                                                          <span class="body-1 font-weight-thin">
                                                            <v-icon
                                                              v-if="item.OncekiDonemBilgi.ToplamAdet < item.DonemBilgi.ToplamAdet"
                                                              medium="" color="green">arrow_drop_up</v-icon>
                                                            <v-icon medium=""
                                                              v-if="item.OncekiDonemBilgi.ToplamAdet == item.DonemBilgi.ToplamAdet"
                                                              color="yellow">compare_arrows</v-icon>
                                                            <v-icon medium
                                                              v-if="item.OncekiDonemBilgi.ToplamAdet > item.DonemBilgi.ToplamAdet"
                                                              color="red">arrow_drop_down</v-icon>
                                                          </span>
                                                        </v-layout>
                                                      </v-flex>
                                                    </v-layout>


                                                    <v-divider light></v-divider>

                                                  </v-card>
                                                </v-flex>

                                                <v-flex pl-2 pt-2 pr-2 xs12 sm6 md4>
                                                  <v-card flat class="black--text">
                                                    <v-divider light></v-divider>

                                                    <v-layout>
                                                      <v-flex xs3 sm3 md4>
                                                        <v-layout align-center="" justify-start="" fill-height="">
                                                          <span class="body-1 font-weight-thin">
                                                            {{ $t('Domestic-revenue') }}
                                                          </span>
                                                        </v-layout>
                                                      </v-flex>
                                                      <v-flex xs3 sm3 md5>
                                                        <v-layout align-center="" justify-end="" fill-height="">
                                                          <span class="body-1 font-weight-thin">
                                                            {{item.OncekiDonemBilgi.IcHatGelirTutar | moneyformat }}{{getparabirimi()}}
                                                            &nbsp;-&nbsp;{{item.DonemBilgi.IcHatGelirTutar | moneyformat }}{{getparabirimi()}}
                                                          </span>
                                                        </v-layout>
                                                      </v-flex>
                                                      <v-flex xs3 sm3 md2>
                                                        <v-layout align-center="" justify-center="" fill-height="">
                                                          <span class="caption font-weight-thin">

                                                            %
                                                            {{ ((item.DonemBilgi.IcHatGelirTutar-item.OncekiDonemBilgi.IcHatGelirTutar) /item.OncekiDonemBilgi.IcHatGelirTutar) * 100 | yuzdekontrol }}
                                                          </span>
                                                        </v-layout>
                                                      </v-flex>
                                                      <v-flex xs3 sm3 md1>
                                                        <v-layout align-center="" justify-end="" fill-height="">
                                                          <span class="body-1 font-weight-thin">
                                                            <v-icon
                                                              v-if="item.OncekiDonemBilgi.IcHatGelirTutar < item.DonemBilgi.IcHatGelirTutar"
                                                              medium="" color="green">arrow_drop_up</v-icon>
                                                            <v-icon medium=""
                                                              v-if="item.OncekiDonemBilgi.IcHatGelirTutar == item.DonemBilgi.IcHatGelirTutar"
                                                              color="yellow">compare_arrows</v-icon>
                                                            <v-icon medium
                                                              v-if="item.OncekiDonemBilgi.IcHatGelirTutar > item.DonemBilgi.IcHatGelirTutar"
                                                              color="red">arrow_drop_down</v-icon>

                                                          </span>
                                                        </v-layout>
                                                      </v-flex>
                                                    </v-layout>

                                                    <v-divider light></v-divider>

                                                    <v-layout>
                                                      <v-flex xs3 sm3 md4>
                                                        <v-layout align-center="" justify-start="" fill-height="">
                                                          <span class="body-1 font-weight-thin">
                                                            {{ $t('International-revenue') }}
                                                          </span>
                                                        </v-layout>
                                                      </v-flex>
                                                      <v-flex xs3 sm3 md5>
                                                        <v-layout align-center="" justify-end="" fill-height="">
                                                          <span class="body-1 font-weight-thin">
                                                            {{item.OncekiDonemBilgi.DisHatGelirTutar | moneyformat }}{{getparabirimi()}}
                                                            &nbsp;-&nbsp;{{item.DonemBilgi.DisHatGelirTutar | moneyformat }}{{getparabirimi()}}
                                                          </span>
                                                        </v-layout>
                                                      </v-flex>
                                                      <v-flex xs3 sm3 md2>
                                                        <v-layout align-center="" justify-center="" fill-height="">
                                                          <span class="caption font-weight-thin">

                                                            %{{ ((item.DonemBilgi.DisHatGelirTutar-item.OncekiDonemBilgi.DisHatGelirTutar) /item.OncekiDonemBilgi.DisHatGelirTutar) * 100 | yuzdekontrol}}
                                                          </span>
                                                        </v-layout>
                                                      </v-flex>
                                                      <v-flex xs3 sm3 md1>
                                                        <v-layout align-center="" justify-end="" fill-height="">
                                                          <span class="body-1 font-weight-thin">
                                                            <v-icon
                                                              v-if="item.OncekiDonemBilgi.DisHatGelirTutar < item.DonemBilgi.DisHatGelirTutar"
                                                              medium="" color="green">arrow_drop_up</v-icon>
                                                            <v-icon medium=""
                                                              v-if="item.OncekiDonemBilgi.DisHatGelirTutar == item.DonemBilgi.DisHatGelirTutar"
                                                              color="yellow">compare_arrows</v-icon>
                                                            <v-icon medium
                                                              v-if="item.OncekiDonemBilgi.DisHatGelirTutar > item.DonemBilgi.DisHatGelirTutar"
                                                              color="red">arrow_drop_down</v-icon>
                                                          </span>
                                                        </v-layout>
                                                      </v-flex>
                                                    </v-layout>
                                                    <v-divider light></v-divider>
                                                    <v-layout>
                                                      <v-flex xs3 sm3 md4>
                                                        <v-layout align-center="" justify-start="" fill-height="">
                                                          <span class="body-1 font-weight-thin">
                                                            {{ $t('Total-Income') }}
                                                          </span>
                                                        </v-layout>
                                                      </v-flex>
                                                      <v-flex xs3 sm3 md5>
                                                        <v-layout align-center="" justify-end="" fill-height="">
                                                          <span class="body-1 font-weight-thin">
                                                            {{item.OncekiDonemBilgi.ToplamGelirTutar | moneyformat }}{{getparabirimi()}}
                                                            &nbsp;-&nbsp;{{item.DonemBilgi.ToplamGelirTutar | moneyformat }}{{getparabirimi()}}
                                                          </span>
                                                        </v-layout>
                                                      </v-flex>
                                                      <v-flex xs3 sm3 md2>
                                                        <v-layout align-center="" justify-center="" fill-height="">
                                                          <span class="caption font-weight-thin">

                                                            %
                                                            {{ ((item.DonemBilgi.ToplamGelirTutar-item.OncekiDonemBilgi.ToplamGelirTutar) /item.OncekiDonemBilgi.ToplamGelirTutar) * 100 | yuzdekontrol}}
                                                          </span>
                                                        </v-layout>
                                                      </v-flex>
                                                      <v-flex xs3 sm3 md1>
                                                        <v-layout align-center="" justify-end="" fill-height="">
                                                          <span class="body-1 font-weight-thin">
                                                            <v-icon
                                                              v-if="item.OncekiDonemBilgi.ToplamGelirTutar < item.DonemBilgi.ToplamGelirTutar"
                                                              medium="" color="green">arrow_drop_up</v-icon>
                                                            <v-icon medium=""
                                                              v-if="item.OncekiDonemBilgi.ToplamGelirTutar == item.DonemBilgi.ToplamGelirTutar"
                                                              color="yellow">compare_arrows</v-icon>
                                                            <v-icon medium
                                                              v-if="item.OncekiDonemBilgi.ToplamGelirTutar > item.DonemBilgi.ToplamGelirTutar"
                                                              color="red">arrow_drop_down</v-icon>
                                                          </span>
                                                        </v-layout>
                                                      </v-flex>
                                                    </v-layout>


                                                    <v-divider light></v-divider>

                                                  </v-card>
                                                </v-flex>

                                                <v-flex pl-2 pt-2 pr-2 xs12 sm6 md4>
                                                  <v-card flat class="black--text">
                                                    <v-divider light></v-divider>

                                                    <v-layout>
                                                      <v-flex xs3 sm3 md4>
                                                        <v-layout align-center="" justify-start="" fill-height="">
                                                          <span class="body-1 font-weight-thin">
                                                            {{ $t('Domestic-turnover') }}
                                                          </span>
                                                        </v-layout>
                                                      </v-flex>
                                                      <v-flex xs3 sm3 md5>
                                                        <v-layout align-center="" justify-end="" fill-height="">
                                                          <span class="caption font-weight-thin">
                                                            {{item.OncekiDonemBilgi.IcHatCiroTutar | moneyformat}}{{getparabirimi()}}
                                                            &nbsp;-&nbsp;{{item.DonemBilgi.IcHatCiroTutar | moneyformat}}{{getparabirimi()}}
                                                          </span>
                                                        </v-layout>
                                                      </v-flex>
                                                      <v-flex xs3 sm3 md2>
                                                        <v-layout align-center="" justify-center="" fill-height="">
                                                          <span class="caption font-weight-thin">

                                                            %
                                                            {{ ((item.DonemBilgi.IcHatCiroTutar-item.OncekiDonemBilgi.IcHatCiroTutar) /item.OncekiDonemBilgi.IcHatCiroTutar) * 100 | yuzdekontrol }}
                                                          </span>
                                                        </v-layout>
                                                      </v-flex>
                                                      <v-flex xs3 sm3 md1>
                                                        <v-layout align-center="" justify-end="" fill-height="">
                                                          <span class="caption font-weight-thin">

                                                            <v-icon
                                                              v-if="item.OncekiDonemBilgi.IcHatCiroTutar < item.DonemBilgi.IcHatCiroTutar"
                                                              medium="" color="green">arrow_drop_up</v-icon>
                                                            <v-icon medium=""
                                                              v-if="item.OncekiDonemBilgi.IcHatCiroTutar == item.DonemBilgi.IcHatCiroTutar"
                                                              color="yellow">compare_arrows</v-icon>
                                                            <v-icon medium
                                                              v-if="item.OncekiDonemBilgi.IcHatCiroTutar > item.DonemBilgi.IcHatCiroTutar"
                                                              color="red">arrow_drop_down</v-icon>

                                                          </span>
                                                        </v-layout>
                                                      </v-flex>
                                                    </v-layout>

                                                    <v-divider light></v-divider>

                                                    <v-layout>
                                                      <v-flex xs3 sm3 md4>
                                                        <v-layout align-center="" justify-start="" fill-height="">
                                                          <span class="body-1 font-weight-thin">
                                                            {{ $t('International-turnover') }}
                                                          </span>
                                                        </v-layout>
                                                      </v-flex>
                                                      <v-flex xs3 sm3 md5>
                                                        <v-layout align-center="" justify-end="" fill-height="">
                                                          <span class="caption font-weight-thin">
                                                            {{item.OncekiDonemBilgi.DisHatCiroTutar | moneyformat}}{{getparabirimi()}}
                                                            &nbsp;-&nbsp;
                                                            {{item.DonemBilgi.DisHatCiroTutar | moneyformat}}{{getparabirimi()}}
                                                          </span>
                                                        </v-layout>
                                                      </v-flex>
                                                      <v-flex xs3 sm3 md2>
                                                        <v-layout align-center="" justify-center="" fill-height="">
                                                          <span class="caption font-weight-thin">

                                                            %{{ ((item.DonemBilgi.DisHatCiroTutar-item.OncekiDonemBilgi.DisHatCiroTutar) /item.OncekiDonemBilgi.DisHatCiroTutar) * 100 | yuzdekontrol}}
                                                          </span>
                                                        </v-layout>
                                                      </v-flex>
                                                      <v-flex xs3 sm3 md1>
                                                        <v-layout align-center="" justify-end="" fill-height="">
                                                          <span class="caption font-weight-thin">
                                                            <v-icon
                                                              v-if="item.OncekiDonemBilgi.DisHatCiroTutar < item.DonemBilgi.DisHatCiroTutar"
                                                              medium="" color="green">arrow_drop_up</v-icon>
                                                            <v-icon medium=""
                                                              v-if="item.OncekiDonemBilgi.DisHatCiroTutar == item.DonemBilgi.DisHatCiroTutar"
                                                              color="yellow">compare_arrows</v-icon>
                                                            <v-icon medium
                                                              v-if="item.OncekiDonemBilgi.DisHatCiroTutar > item.DonemBilgi.DisHatCiroTutar"
                                                              color="red">arrow_drop_down</v-icon>
                                                          </span>
                                                        </v-layout>
                                                      </v-flex>
                                                    </v-layout>
                                                    <v-divider light></v-divider>
                                                    <v-layout>
                                                      <v-flex xs3 sm3 md4>
                                                        <v-layout align-center="" justify-start="" fill-height="">
                                                          <span class="body-1 font-weight-thin">
                                                            {{ $t('Total-Revenue') }}
                                                          </span>
                                                        </v-layout>
                                                      </v-flex>
                                                      <v-flex xs3 sm3 md5>
                                                        <v-layout align-center="" justify-end="" fill-height="">
                                                          <span class="caption font-weight-thin">
                                                            {{item.OncekiDonemBilgi.ToplamCiroTutar | moneyformat}}{{getparabirimi()}}
                                                            &nbsp;-&nbsp;{{item.DonemBilgi.ToplamCiroTutar | moneyformat}}{{getparabirimi()}}
                                                          </span>
                                                        </v-layout>
                                                      </v-flex>
                                                      <v-flex xs3 sm3 md2>
                                                        <v-layout align-center="" justify-center="" fill-height="">
                                                          <span class="caption font-weight-thin">

                                                            %
                                                            {{ ((item.DonemBilgi.ToplamCiroTutar-item.OncekiDonemBilgi.ToplamCiroTutar) /item.OncekiDonemBilgi.ToplamCiroTutar) * 100 | yuzdekontrol}}
                                                          </span>
                                                        </v-layout>
                                                      </v-flex>
                                                      <v-flex xs3 sm3 md1>
                                                        <v-layout align-center="" justify-end="" fill-height="">
                                                          <span class="caption font-weight-thin">
                                                            <v-icon
                                                              v-if="item.OncekiDonemBilgi.ToplamCiroTutar < item.DonemBilgi.ToplamCiroTutar"
                                                              medium="" color="green">arrow_drop_up</v-icon>
                                                            <v-icon medium=""
                                                              v-if="item.OncekiDonemBilgi.ToplamCiroTutar == item.DonemBilgi.ToplamCiroTutar"
                                                              color="yellow">compare_arrows</v-icon>
                                                            <v-icon medium
                                                              v-if="item.OncekiDonemBilgi.ToplamCiroTutar > item.DonemBilgi.ToplamCiroTutar"
                                                              color="red">arrow_drop_down</v-icon>
                                                          </span>
                                                        </v-layout>
                                                      </v-flex>
                                                    </v-layout>


                                                    <v-divider light></v-divider>

                                                  </v-card>
                                                </v-flex>

                                              </v-layout>
                                            </v-card-actions>
                                          </v-card>
                                        </v-card>
                                      </v-flex>


                                    </v-flex>
                                  </v-layout>
                                </v-card-actions>
                              </v-card>
                            </v-card>
                          </v-flex>
                        </v-layout>
                      </v-card-title>
                    </v-card>
                  </v-hover>
                </v-flex>




                <!--

 var yenikayit = {
            Kod: element.Cari.Kod,
            Unvan: element.Cari.Unvan,
            OncekiDonemPay:element.OncekiDonemBilgi.Pay,
            DonemPay:element.DonemBilgi.Pay,
            GrafikAdet: {
              rows: rowsadet,
              column: ['tip', 'ÖncekiDönem', 'Dönem']
            },
            GrafikGelir: {
              rows: rowsgelirler,
              column: ['tip', 'ÖncekiDönem', 'Dönem']
            },
            GrafikCiro: {
              rows: rowscirolar,
              column: ['tip', 'ÖncekiDönem', 'Dönem']
            }
          }

 -->







                <v-layout row="" wrap v-if="listtype==1">


                  <v-flex pb-3 v-for="item in grafikitems" v-bind:key="item.id" xs12 sm12 md12>
                    <v-hover>
                      <v-card flat="" slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`" class="mx-auto"
                        width="100%">
                        <v-card-title>
                          <v-layout row wrap>



                            <v-flex xs12 sm12 md12>
                              <v-card flat class="white--text">
                                <v-card flat="">
                                  <v-card-actions>
                                    <v-layout row wrap>
                                      <v-flex xs12 sm12 md12 pr-1>
                                        <v-flex xs12 sm12 md12>
                                          <v-card flat class="black--text">
                                            <v-card flat="">
                                              <v-card-actions>
                                                <v-layout row wrap>
                                                  <v-flex xs12 sm12 md12>
                                                    <v-layout pl-3 align-center="" justify-start="" fill-height="">
                                                      <v-icon color="red">person</v-icon> &nbsp; <span
                                                        class="subheading black--text font-weight-"> {{item.Kod}} -
                                                        {{item.Unvan}}
                                                      </span> <span class="body-1 black--text font-weight-thin"> &nbsp;
                                                        &nbsp;( {{ $t('Share-Previous-Period') }} : %{{item.OncekiDonemPay}} - {{$t('Period-Share')}}:
                                                        %{{item.DonemPay}})
                                                      </span>
                                                    </v-layout>
                                                  </v-flex>

                                                  <v-flex pa-1 xs12 sm6 md4>
                                                    <v-card flat>
                                                      <ve-histogram hide-details :colors="colors" height="200px"
                                                        :loading="loading1" :judge-width="true"
                                                        :settings="chartSettingsadet" :data="item.dataadet">
                                                      </ve-histogram>
                                                    </v-card>
                                                  </v-flex>

                                                  <v-flex pa-1 xs12 sm6 md4>
                                                    <v-card flat>
                                                      <ve-histogram hide-details :colors="colors"
                                                        :settings="chartSettingsgelir" height="200px"
                                                        :loading="loading1" :judge-width="true" :data="item.datagelir">
                                                      </ve-histogram>
                                                    </v-card>
                                                  </v-flex>

                                                  <v-flex pa-1 xs12 sm6 md4>
                                                    <v-card flat>
                                                      <ve-histogram hide-details :colors="colors" height="200px"
                                                        :loading="loading1" :judge-width="true"
                                                        :settings="chartSettingsgelir" :data="item.dataciro">
                                                      </ve-histogram>
                                                    </v-card>
                                                  </v-flex>

                                                </v-layout>
                                              </v-card-actions>
                                            </v-card>
                                          </v-card>
                                        </v-flex>


                                      </v-flex>
                                    </v-layout>
                                  </v-card-actions>
                                </v-card>
                              </v-card>
                            </v-flex>
                          </v-layout>
                        </v-card-title>
                      </v-card>
                    </v-hover>
                  </v-flex>

                </v-layout>

                <v-flex md12 xs12 sm12 v-if="itemssatis.length>0 && recordcount<itemssatisview.length" pa-2>
                  <v-layout justify-center="">
                    <v-btn color="info" flat @click="kayitgoster()">{{ $t('Show-More-Records') }}</v-btn>
                  </v-layout>
                </v-flex>

              </v-layout>
            </v-form>
          </v-container>



          <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
            :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
            {{ text1 }}
            <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
          </v-snackbar>



          <v-dialog v-model="dialogfiltre" scrollable="" persistent="" max-width="400px">
            <v-card flat="" color="grey lighten-5">
              <v-card-title>{{ $t('Filter-selection') }}</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout row="" wrap="">

                  <v-flex xs12 sm12 md12 pa-1>
                    <v-card flat class="white--text">
                      <v-card color="grey lighten-5" flat="">
                        <v-card-actions>
                          <v-layout row="" wrap="">

                            <v-flex xs12 sm12 md12>
                               <cariaracomp v-bind:etiket="$t('Currentcode_label')" :loading="loading" v-bind:value="Rapor.CariKodu" v-model="Rapor.CariKodu"></cariaracomp>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                               <cariaracomp v-bind:etiket="$t('Main-Account')" :loading="loading" v-bind:value="Rapor.AnaHesap" v-model="Rapor.AnaHesap"></cariaracomp>
                            </v-flex>
                            <v-flex xs12 sm12 md12>

                              <v-select :items="hesapitems" hide-details v-model="Rapor.HesapGrubu" :label="$t('Account-Group')"
                                multiple item-text="Adi" item-value="Kod">
                                <template slot="selection" slot-scope="{ item, index }">
                                  <v-chip v-if="index === 0">
                                    <h4> <span>{{ item.Kod }}</span> </h4>
                                  </v-chip>
                                  <span v-if="index === 1" class="grey--text caption">(+{{
                                 Rapor.HesapGrubu.length - 1 }} {{ $t('other-record') }} )</span>
                                </template>
                              </v-select>
                            </v-flex>

                            <v-flex xs12 sm12 md12>

                              <v-select :items="masrafitems" hide-details v-model="Rapor.Masraf" :label="this.$t('Expense-Center')"
                                multiple item-text="Code" item-value="CodeName">
                                <template slot="selection" slot-scope="{ item, index }">
                                  <v-chip v-if="index === 0">
                                    <h4> <span>{{ item.Code }}</span> </h4>
                                  </v-chip>
                                  <span v-if="index === 1" class="grey--text caption">(+{{
                                Rapor.Masraf.length - 1 }} {{ $t('other-record') }})</span>
                                </template>
                              </v-select>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-checkbox v-model="Rapor.GelirGoster" :label="$t('Show-Incomes')" hide-details="">
                              </v-checkbox>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-checkbox v-model="Rapor.CiroGoster" :label="$t('Show-Revenues')" hide-details="">
                              </v-checkbox>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-checkbox v-model="tumsirketler" :label="$t('All-Companies')" hide-details=""></v-checkbox>
                            </v-flex>

                          </v-layout>
                        </v-card-actions>
                      </v-card>
                    </v-card>
                  </v-flex>



                </v-layout>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="filtreiptal()">{{$t("cancel_button")}}</v-btn>
                <v-btn color="blue darken-1" flat @click.native="filtrekayit()">{{ $t('Apply-Filters') }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>


<script>
  import auth from '../../../api/auth'
  import tarihcomp from '../customcomp/tarihim'
  import helpers from "@/components/app/customcomp/helpers.js"
  import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue"
  import havayollaricomp from "@/components/app/bilet/partpage/havayollaricomp.vue"
  import analizcomp from "@/components/app/bilet/partpage/analizcomp.vue"
  import VeHistogram from 'v-charts/lib/histogram.common'
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"
  import cariaracomp from '@/components/app/customcomp/cariaracomp.vue'
  import ReportTable from '@/components/app/customcomp/ReportTable.vue'



  export default {

    data() {
      return {
         mailDialog: false,
        mailValid: false,
        mailLoading: false,
        mailPayload: {
          To: "",
          AgencyName: "",
          DocType: "", 
          AgentFullName: "",
          CustomBody: ""
        },
        rules: {
          required: v => !!v || this.$t('Required-Field'),
          email: v => !v || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || this.$t('Enter-Valid-Email')
        },
        sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0,
        },
        filtrevarmi: false,
        reportHasSearched: false,
        grafikitems: [],
        height: 50,
        chartadet: {
          rows: [{
            type: 'Dom.Count',
            previous: 10,
            period: '20'
          }, {
            type: 'Int.Count',
            previous: 10,
            period: '20'
          }, {
            type: this.$t("totalnumber"),
            previous: 10,
            period: '20'
          }],
          columns: ['type', 'previous', 'period'],
        },
        chartSettingsadet: {
          title: {
            show: true,
            text: 'eaieaei'
          },
          label: {
            show: true
          },
          axisSite: {
            right: ['growthRate']
          },
          yAxisType: ['KMB'],
          yAxisName: ['pcs']
        },
        chartSettingsgelir: {
          label: {
            show: true
          },
          yAxisName: ['Amount']
        },
        colors: ['#F44336', '#03A9F4'],
        recordcount: 50,
        listtype: '0',
        hesapitems: [],
        masrafitems: [],
        referansitems: [],
        evraktipi: [],
        search: '',
        searchsatilanbilet: null,
        searchiadebilet: null,
        searchvoid: null,
        headerssatis: [{
            text: this.$t('Account-No'),
            value: 'Cari.Kod'
          },
          {
            text: this.$t('Account-Name'),
            value: 'Cari.Unvan',
          },
          {
            text: 'Pre. Dom. Count',
            value: 'OncekiDonemBilgi.IcHatAdet'
          },
          {
            text: 'Pre int. Count',
            value: 'OncekiDonemBilgi.DisHatAdet'
          },
          {
            text: 'Pre. Count',
            value: 'OncekiDonemBilgi.ToplamAdet'
          },
          {
            text: 'Pre. Dom.Total',
            value: 'OncekiDonemBilgi.IcHatGelirTutar'
          },
          {
            text: 'Pre. int.Total',
            value: 'OncekiDonemBilgi.DisHatGelirTutar'
          },
          {
            text: 'Pre. Total',
            value: 'OncekiDonemBilgi.ToplamGelirTutar'
          },
          {
            text: 'Pre.Dom.',
            value: 'OncekiDonemBilgi.IcHatCiroTutar'
          },
          {
            text: this.$t('Previous-Period-International-Turnover'),
            value: 'OncekiDonemBilgi.DisHatCiroTutar'
          },
          {
            text: 'Pre. End.',
            value: 'OncekiDonemBilgi.ToplamCiroTutar'
          },
          {
            text: 'Pre. Pay',
            value: 'OncekiDonemBilgi.ToplamCiroTutar.Pay'
          },
          {
            text: this.$t('Domestic-quantity'),
            value: 'DonemBilgi.IcHatAdet'
          },
          {
            text: this.$t('International-Quantity'),
            value: 'DonemBilgi.DisHatAdet'
          },
          {
            text: 'Total Piece',
            value: 'DonemBilgi.ToplamAdet'
          },
          {
            text: 'Domestic Revenue',
            value: 'DonemBilgi.IcHatGelirTutar'
          },
          {
            text: 'International Line Revenue',
            value: 'DonemBilgi.DisHatGelirTutar'
          },
          {
            text: 'Total Revenue',
            value: 'DonemBilgi.ToplamGelirTutar'
          },
          {
            text: 'Domestic Turnover',
            value: 'DonemBilgi.IcHatCiroTutar'
          },
          {
            text: 'International Line Turnover',
            value: 'DonemBilgi.DisHatCiroTutar'
          },
          {
            text: this.$t('Total-Revenue'),
            value: 'DonemBilgi.ToplamCiroTutar'
          },
          {
            text: this.$t('Share'),
            value: 'DonemBilgi.ToplamCiroTutar.Pay'
          }
        ],

        ODonemToplam: {
          DisHatAdet: 0,
          DisHatCiroTutar: 0,
          DisHatGelirTutar: 0,
          IcHatAdet: 0,
          IcHatCiroTutar: 0,
          IcHatGelirTutar: 0,
          Pay: 0,
          ToplamAdet: 0,
          ToplamCiroTutar: 0,
          ToplamGelirTutar: 0,
        },

        DonemToplam: {
          DisHatAdet: 0,
          DisHatCiroTutar: 0,
          DisHatGelirTutar: 0,
          IcHatAdet: 0,
          IcHatCiroTutar: 0,
          IcHatGelirTutar: 0,
          Pay: 0,
          ToplamAdet: 0,
          ToplamCiroTutar: 0,
          ToplamGelirTutar: 0,
        },



        Rapor: {
          SirketKodu: null,
          CariKodu: null,
          BaslangicDonem: null,
          BitisDonem: null,
          BaslangicOncekiDonem: null,
          BitisOncekiDonem: null,
          AnaHesap: null,
          HesapGrubu: [],
          Masraf: [],
          GelirGoster: true,
          CiroGoster: true,
        },

        valid: true,
        tumsirketler: '',

        loading: false,
        loading1: false,

        items: [],
        load: false,
        load1: true,
        search3: '',

        renk1: 'info',
        dialogfiltre: false,
        hesapkodu: [],
        kredikarti: [],
        statecari: [],
        searchcari: '',
        statecari1: [],
        searchcari1: '',
        progress: false,
        tooltip: false,
        el: null,
        yok: false,
        itemssatis: [],
        itemssatisview: [],
        itemsiade: [],

        butondurum: true,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        dictionary: {
          custom: {

            tarihsec: {
              required: () => this.$t('Please-select-a-date')
            },
            tarihsec1: {
              required: () => this.$t('Please-select-a-date')
            },
          }
        },
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path
      })
    },
    beforeMount: beforeMount,

    mounted() {
      this.$validator.localize('en', this.dictionary)
      this.el = this.$refs.fab.$el


      this.sayfayetki = helpers.pageScreenAuth(this.$route.name)

      if (this.sayfayetki.Status == true) {

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        var params3 = {
          CompanyCode: credentials.SirketKodu
        }
        this.$http.post(auth.API_URL + 'api/ExpenseCenter/List', params3, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.masrafitems = response.body
        }, (response) => {
          if (response.status === 0) {
            this.text1 = this.$t('Service-Unavailable')
            this.snackbar = true
          } else {
            this.text1 = this.$t('Service-Unavailable')
            this.snackbar = true
          }
        })

        this.$http.post(auth.API_URL + 'api/Definitions/CurrentGroupList', params3, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.hesapitems = response.body
        }, (response) => {
          if (response.status === 0) {
            this.text1 = this.$t('Service-Unavailable')
            this.snackbar = true
          } else {
            this.text1 = this.$t('Service-Unavailable')
            this.snackbar = true
          }
        })
        this.$http.post(auth.API_URL + 'api/doctype/List', params3, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.evraktipi = response.body

        }, (response) => {
         if (response.status === 0) {
            this.text1 = this.$t('Service-Unavailable')
            this.snackbar = true
          } else {
            this.text1 = this.$t('Service-Unavailable')
            this.snackbar = true
          }
        })
        this.grafikolustur()

      } else {

        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

          if (sonuc == true) {

            if (this.prevRoute != null) {
              let url = '#' + this.prevRoute
              window.open(url, '_self')
            } else {
              let url = '#/'
              window.open(url, '_self')
            }
          }
        });
      }
    },
    filters: {
      yuzdekontrol: function (y) {

        if (y == Infinity || isNaN(y) == true) {
          return '-'
        } else {
          var a = String(Number((y).toFixed(2)));
          return a.replace("-", "")
        }
      },

      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },
      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      }
    },

    components: {
      'tarihcomp': tarihcomp,
      referansmerkezicomp,
      analizcomp,
      havayollaricomp,
      VeHistogram,
      yetkidialog,
      cariaracomp,
      ReportTable
    },
    watch: {
      'listtype': function (val) {

        if (val == 1) {
          this.grafikolustur()
        }
      }
    },
    methods: {

  openMailDialog: function () {
    if (this.$refs && this.$refs.mailForm && this.$refs.mailForm.resetValidation) {
      this.$refs.mailForm.resetValidation();
    }

    var pageDocType = this.$t('Comparative-Customer-Report');
    if (!this.mailPayload || !this.mailPayload.DocType || this.mailPayload.DocType !== pageDocType) {
      this.mailPayload.DocType = pageDocType;
    }

    this.mailDialog = true;
  },

  closeMailDialog: function () {
    this.mailDialog = false;
  },

  sendMail: function () {
    var _this = this;

    if (!(_this.$refs && _this.$refs.mailForm && _this.$refs.mailForm.validate && _this.$refs.mailForm.validate())) {
      return;
    }

    var bas  = (_this.Rapor && _this.Rapor.BaslangicDonem) ? new Date(_this.Rapor.BaslangicDonem) : null;
    var bit  = (_this.Rapor && _this.Rapor.BitisDonem) ? new Date(_this.Rapor.BitisDonem) : null;
    var obas = (_this.Rapor && _this.Rapor.BaslangicOncekiDonem) ? new Date(_this.Rapor.BaslangicOncekiDonem) : null;
    var obit = (_this.Rapor && _this.Rapor.BitisOncekiDonem) ? new Date(_this.Rapor.BitisOncekiDonem) : null;

    var simdikiOk = (bas && bit && bas <= bit);
    var oncekiOk  = (obas && obit && obas <= obit);

    if (!(simdikiOk || oncekiOk)) {
      _this.text1 = _this.$t('start-date-cannot-greater-than-end-date');
      _this.snackbar = true;
      return;
    }

    var credentialsRaw = window.localStorage.getItem('credentials');
    var credentials = credentialsRaw ? JSON.parse(credentialsRaw) : {};
    var companyCode = (_this.tumsirketler === true)
      ? '0'
      : (credentials && credentials.SirketKodu) ? credentials.SirketKodu : null;

    var inputObj = {
      SirketKodu: companyCode,
      CariKodu: (_this.Rapor && _this.Rapor.CariKodu) ? _this.Rapor.CariKodu : null,
      BaslangicDonem: (_this.Rapor && _this.Rapor.BaslangicDonem) ? _this.Rapor.BaslangicDonem : null,
      BitisDonem: (_this.Rapor && _this.Rapor.BitisDonem) ? _this.Rapor.BitisDonem : null,
      BaslangicOncekiDonem: (_this.Rapor && _this.Rapor.BaslangicOncekiDonem) ? _this.Rapor.BaslangicOncekiDonem : null,
      BitisOncekiDonem: (_this.Rapor && _this.Rapor.BitisOncekiDonem) ? _this.Rapor.BitisOncekiDonem : null,
      AnaHesap: (_this.Rapor && _this.Rapor.AnaHesap) ? _this.Rapor.AnaHesap : null,
      HesapGrubu: (_this.Rapor && Array.isArray(_this.Rapor.HesapGrubu)) ? _this.Rapor.HesapGrubu : [],
      Masraf: (_this.Rapor && Array.isArray(_this.Rapor.Masraf)) ? _this.Rapor.Masraf : [],
      GelirGoster: !!(_this.Rapor && _this.Rapor.GelirGoster),
      CiroGoster: !!(_this.Rapor && _this.Rapor.CiroGoster)
    };

    var mailObj = {
      To: (_this.mailPayload && _this.mailPayload.To) ? _this.mailPayload.To : "",
      AgencyName: (_this.mailPayload && _this.mailPayload.AgencyName) ? _this.mailPayload.AgencyName : "",
      DocType: (_this.mailPayload && _this.mailPayload.DocType)
        ? _this.mailPayload.DocType
        : _this.$t('Comparative-Customer-Report'),
      AgentFullName: (_this.mailPayload && _this.mailPayload.AgentFullName) ? _this.mailPayload.AgentFullName : "",
      CustomBody: (_this.mailPayload && _this.mailPayload.CustomBody) ? _this.mailPayload.CustomBody : ""
    };

    var payload = { Input: inputObj, Mail: mailObj };

    _this.mailLoading = true;

    var endpoint = auth.API_URL + 'api/TicketReport/MailGonderMukayeseliMusteriTakipHtml';

    _this.$http.post(
      endpoint,
      payload,
      { headers: { 'Authorization': 'Bearer ' + auth.getAuthHeader() } }
    ).then(function () {
      _this.mailLoading = false;
      _this.mailDialog = false;
      _this.text1 = _this.$t('Mail-Sent');
      _this.snackbar = true;
    }, function (err) {
      _this.mailLoading = false;
      var body = (err && (err.body || err.data)) ? (err.body || err.data) : {};
      var msg = (body && (body.Message || body.message)) || err.statusText || _this.$t('Mail-Could-Not-Be-Sent');
      _this.text1 = msg;
      _this.snackbar = true;
    });
  },




          getparabirimi() {
        return helpers.getparabirimi()
      },
      grafikolustur() {
        this.grafikitems = [];
        this.itemssatis.forEach(element => {
          var chartadet = {
            rows: [{
              type: 'dom.',
              previous : element.OncekiDonemBilgi.IcHatAdet,
              period: element.DonemBilgi.IcHatAdet
            }, {
              type: 'int.',
              previous: element.OncekiDonemBilgi.DisHatAdet,
              period: element.DonemBilgi.DisHatAdet
            }, {
              type: this.$t("totalnumber"),
              previous: element.OncekiDonemBilgi.ToplamAdet,
              period: element.DonemBilgi.ToplamAdet
            }],
            columns: ['type', 'previous', 'period'],
          }
          var chartgelir = {
            rows: [{
              type: 'dom.',
              previous: element.OncekiDonemBilgi.IcHatGelirTutar,
              period: element.DonemBilgi.IcHatGelirTutar
            }, {
              type: 'int.',
              previous: element.OncekiDonemBilgi.DisHatGelirTutar,
              period: element.DonemBilgi.DisHatGelirTutar
            }, {
              type: this.$t("Total"),
              previous: element.OncekiDonemBilgi.ToplamGelirTutar,
              period: element.DonemBilgi.ToplamGelirTutar
            }],
            columns: ['type', 'previous', 'period'],
          }
          var chartciro = {
            rows: [{
              type: 'dom.end.',
              previous: element.OncekiDonemBilgi.IcHatCiroTutar,
              period: element.DonemBilgi.IcHatCiroTutar
            }, {
              type: 'int.end.',
              previous: element.OncekiDonemBilgi.DisHatCiroTutar,
              period: element.DonemBilgi.DisHatCiroTutar
            }, {
              type: this.$t("Total"),
              previous: element.OncekiDonemBilgi.ToplamCiroTutar,
              period: element.DonemBilgi.ToplamCiroTutar
            }],
            columns: ['type', 'previous', 'period'],
          }

          var yenikayit = {
            Kod: element.Cari.Kod,
            Unvan: element.Cari.Unvan,
            OncekiDonemPay: element.OncekiDonemBilgi.Pay,
            DonemPay: element.DonemBilgi.Pay,
            dataadet: chartadet,
            datagelir: chartgelir,
            dataciro: chartciro
          }

          this.grafikitems.push(yenikayit);
        });
      },
      kayitgoster() {
        this.recordcount = this.recordcount + 50;
        this.itemssatis = this.itemssatisview.slice(0, this.recordcount)

        if (this.listtype == 1) {
          this.grafikolustur();
        }
      },
      getList: getList,
      getListHtml: getListHtml,
      getListExcel: getListExcel,
      filtrele: filtrele,
      filtrekayit: filtrekayit,
      filtreiptal: filtreiptal

    },
    computed: {
      comparativeReportHeaders() {
        return [
          {text:this.$t('Accound-Code'),value:'_CariKod',type:'text',align:'left',visible:true,sortable:true},
          {text:this.$t('Account-Name'),value:'_CariUnvan',type:'text',align:'left',visible:true,sortable:true},
          {text:this.$t('Prior-Period-Grand-Total')+' - '+this.$t('Domestic-quantity'),value:'_O_IcHatAdet',type:'number',align:'right',visible:true,sortable:true},
          {text:this.$t('Prior-Period-Grand-Total')+' - '+this.$t('International-Quantity'),value:'_O_DisHatAdet',type:'number',align:'right',visible:true,sortable:true},
          {text:this.$t('Prior-Period-Grand-Total')+' - '+this.$t('totalnumber'),value:'_O_ToplamAdet',type:'number',align:'right',visible:true,sortable:true},
          {text:this.$t('Prior-Period-Grand-Total')+' - '+this.$t('Domestic-revenue'),value:'_O_IcHatGelirTutar',type:'money',align:'right',visible:true,sortable:true},
          {text:this.$t('Prior-Period-Grand-Total')+' - '+this.$t('International-revenue'),value:'_O_DisHatGelirTutar',type:'money',align:'right',visible:true,sortable:true},
          {text:this.$t('Prior-Period-Grand-Total')+' - '+this.$t('Revenue-Amounts'),value:'_O_ToplamGelirTutar',type:'money',align:'right',visible:true,sortable:true},
          {text:this.$t('Prior-Period-Grand-Total')+' - '+this.$t('Domestic-Line'),value:'_O_IcHatCiroTutar',type:'money',align:'right',visible:true,sortable:true},
          {text:this.$t('Prior-Period-Grand-Total')+' - '+this.$t('International-Line'),value:'_O_DisHatCiroTutar',type:'money',align:'right',visible:true,sortable:true},
          {text:this.$t('Prior-Period-Grand-Total')+' - '+this.$t('Revenue-Amounts'),value:'_O_ToplamCiroTutar',type:'money',align:'right',visible:true,sortable:true},
          {text:this.$t('Share-Previous-Period'),value:'_O_Pay',type:'number',align:'right',visible:true,sortable:true},
          {text:this.$t('Current-Period-Grand-Total')+' - '+this.$t('Domestic-quantity'),value:'_D_IcHatAdet',type:'number',align:'right',visible:true,sortable:true},
          {text:this.$t('Current-Period-Grand-Total')+' - '+this.$t('International-Quantity'),value:'_D_DisHatAdet',type:'number',align:'right',visible:true,sortable:true},
          {text:this.$t('Current-Period-Grand-Total')+' - '+this.$t('totalnumber'),value:'_D_ToplamAdet',type:'number',align:'right',visible:true,sortable:true},
          {text:this.$t('Current-Period-Grand-Total')+' - '+this.$t('Domestic-revenue'),value:'_D_IcHatGelirTutar',type:'money',align:'right',visible:true,sortable:true},
          {text:this.$t('Current-Period-Grand-Total')+' - '+this.$t('International-revenue'),value:'_D_DisHatGelirTutar',type:'money',align:'right',visible:true,sortable:true},
          {text:this.$t('Current-Period-Grand-Total')+' - '+this.$t('Revenue-Amounts'),value:'_D_ToplamGelirTutar',type:'money',align:'right',visible:true,sortable:true},
          {text:this.$t('Current-Period-Grand-Total')+' - '+this.$t('Domestic-Line'),value:'_D_IcHatCiroTutar',type:'money',align:'right',visible:true,sortable:true},
          {text:this.$t('Current-Period-Grand-Total')+' - '+this.$t('International-Line'),value:'_D_DisHatCiroTutar',type:'money',align:'right',visible:true,sortable:true},
          {text:this.$t('Current-Period-Grand-Total')+' - '+this.$t('Revenue-Amounts'),value:'_D_ToplamCiroTutar',type:'money',align:'right',visible:true,sortable:true},
          {text:this.$t('Period-Share'),value:'_D_Pay',type:'number',align:'right',visible:true,sortable:true}
        ];
      },
      comparativeReportItems() {
        return (this.itemssatisview || []).map(function(item){
          var row=Object.assign({},item), o=item&&item.OncekiDonemBilgi?item.OncekiDonemBilgi:{}, d=item&&item.DonemBilgi?item.DonemBilgi:{};
          row._CariKod=item&&item.Cari?(item.Cari.Kod||''):'';
          row._CariUnvan=item&&item.Cari?(item.Cari.Unvan||''):'';
          Object.keys(o).forEach(function(key){row['_O_'+key]=o[key];});
          Object.keys(d).forEach(function(key){row['_D_'+key]=d[key];});
          return row;
        });
      },
      comparativeExportMetaItems() {
        return [
          {label:this.$t('Current-Period-Starting-Date'),value:this.Rapor.BaslangicDonem,type:'date'},
          {label:this.$t('Current-Period-Ending-Date'),value:this.Rapor.BitisDonem,type:'date'},
          {label:this.$t('Period-Starting-Date-Compared'),value:this.Rapor.BaslangicOncekiDonem,type:'date'},
          {label:this.$t('Period-Ending-Date-Compared'),value:this.Rapor.BitisOncekiDonem,type:'date'},
          {label:this.$t('Currentcode_label'),value:this.Rapor.CariKodu||''},
          {label:this.$t('Main-Account'),value:this.Rapor.AnaHesap||''},
          {label:this.$t('Account-Group'),value:Array.isArray(this.Rapor.HesapGrubu)?this.Rapor.HesapGrubu.join(', '):''},
          {label:this.$t('Expense-Center-v2'),value:Array.isArray(this.Rapor.Masraf)?this.Rapor.Masraf.join(', '):''},
          {label:this.$t('All-Companies'),value:this.tumsirketler===true?this.$t('Yes'):this.$t('No')}
        ];
      },
      comparativeSummaryCards() {
        var d=this.DonemToplam||{}, o=this.ODonemToplam||{};
        return [
          {title:this.$t('Current-Period-Grand-Total'),items:[
            {label:this.$t('Domestic-quantity'),value:d.IcHatAdet||0,type:'number'},
            {label:this.$t('International-Quantity'),value:d.DisHatAdet||0,type:'number'},
            {label:this.$t('totalnumber'),value:d.ToplamAdet||0,type:'number'},
            {label:this.$t('Received-Amounts'),value:d.ToplamGelirTutar||0,type:'money'},
            {label:this.$t('Revenue-Amounts'),value:d.ToplamCiroTutar||0,type:'money'},
            {label:this.$t('Share'),value:d.Pay||0,type:'number'}]},
          {title:this.$t('Prior-Period-Grand-Total'),items:[
            {label:this.$t('Domestic-quantity'),value:o.IcHatAdet||0,type:'number'},
            {label:this.$t('International-Quantity'),value:o.DisHatAdet||0,type:'number'},
            {label:this.$t('totalnumber'),value:o.ToplamAdet||0,type:'number'},
            {label:this.$t('Received-Amounts'),value:o.ToplamGelirTutar||0,type:'money'},
            {label:this.$t('Revenue-Amounts'),value:o.ToplamCiroTutar||0,type:'money'},
            {label:this.$t('Share'),value:o.Pay||0,type:'number'}]}
        ];
      },

      myStyles() {
        return {
          height: `${this.height}px`,
          position: 'relative'
        }
      }
    }
  }


  function filtrele() {
    this.dialogfiltre = true

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = {
      CompanyCode: credentials.SirketKodu
    }
    this.$http.post(auth.API_URL + 'api/TicketDefinitons/AirlineList', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.itemsairlinelist = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = this.$t('Service-Unavailable')
        this.progress = false

        this.snackbar = true
      } else {
        this.text1 = this.$t('Service-Unavailable')
        this.progress = false

        this.snackbar = true
      }
    })

    this.$http.post(auth.API_URL + 'api/Definitions/CurrentGroupList', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.hesapgurubu = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = this.$t('Service-Unavailable')
        this.snackbar = true
      } else {
        this.text1 = this.$t('Service-Unavailable')
        this.snackbar = true
      }
    })

    this.$http.post(auth.API_URL + 'api/currency/List', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.doviztipi = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = this.$t('Service-Unavailable-Currency')
        this.snackbar = true
      } else {
        this.text1 = this.$t('Service-Unavailable-Currency')
        this.snackbar = true
      }
    })

    this.$http.post(auth.API_URL + 'api/ExpenseCenter/List', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.masrafmerkezi = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = this.$t('Service-Unavailable')
        this.snackbar = true
      } else {
        this.text1 = this.$t('Service-Unavailable')
        this.snackbar = true
      }
    })
  }

  function filtrekayit() {
    this.filtrevarmi = true
    this.dialogfiltre = false
    this.getList()
  }

  function filtreiptal() {
    this.filtrevarmi = false
    this.dialogfiltre = false
    this.Rapor.CariKodu = null
    this.Rapor.AnaHesap = null
    this.Rapor.HesapGrubu = []
    this.Rapor.Masraf = []
    this.Rapor.GelirGoster = true
    this.Rapor.CiroGoster = true
  }


  function getList() {

    if (this.$refs.formgunluksatis.validate()) {
      this.reportHasSearched = true

      var bastarih = new Date(this.Rapor.BaslangicDonem)
      var bittarih = new Date(this.Rapor.BitisDonem)
      var onbastarih = new Date(this.Rapor.BaslangicOncekiDonem)
      var onbittarih = new Date(this.Rapor.BitisOncekiDonem)

      if (bastarih <= bittarih || onbastarih <= onbittarih) {

        this.progress = true
        this.load1 = false

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        if (this.tumsirketler === true) {
          this.Rapor.SirketKodu = '0'
        } else {
          this.Rapor.SirketKodu = credentials.SirketKodu
        }

        var params = this.Rapor

        this.$http.post(auth.API_URL + 'api/TicketReport/CustomerPursuitReport', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.recordcount = 50

          this.itemssatisview = response.body.DetayList

          this.itemssatis = this.itemssatisview.slice(0, this.recordcount)

          if (this.listtype == 1) {
            this.grafikolustur();
          }

          this.ODonemToplam = response.body.Toplamlar.OncekiDonemToplam
          this.DonemToplam = response.body.Toplamlar.DonemToplam
          this.progress = false
          this.load1 = true

        }, (response) => {
          if (response.status === 0) {
            this.text1 = this.$t('Service-Unavailable')
            this.snackbar = true
            this.progress = false
            this.load1 = true
          } else {
            this.text1 = this.$t('Service-Unavailable')
            this.snackbar = true
            this.progress = false
            this.load1 = true
          }
        })
      } else {
        this.text1 = this.$t('start-date-cannot-greater-than-end-date')
        this.snackbar = true
      }
    }
  }



  function getListHtml() {

    if (this.$refs.formgunluksatis.validate()) {

      var bastarih = new Date(this.Rapor.BaslangicDonem)
      var bittarih = new Date(this.Rapor.BitisDonem)
      var onbastarih = new Date(this.Rapor.BaslangicOncekiDonem)
      var onbittarih = new Date(this.Rapor.BitisOncekiDonem)

      if (bastarih <= bittarih || onbastarih <= onbittarih) {

        this.progress = true
        this.load1 = false

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        var lang = localStorage.getItem('lang')
        if (this.tumsirketler === true) {
          this.Rapor.SirketKodu = '0'
        } else {
          this.Rapor.SirketKodu = credentials.SirketKodu
        }

        var params = this.Rapor

        this.$http
          .post(auth.API_URL + "api/TicketReport/CustomerPursuitReportHtml", params, {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader()
            }
          }).then((response) => {


            this.progress = false
            this.load1 = true
            if (lang=='en')
          {
             var bodyhtml=helpers.getTranslatedHtml(response.bodyText);
             bodyhtml=bodyhtml.toString().replace('<title>MUKAYESELİ MÜŞTERİ TAKİP RAPORU</title>','<title>COMPARATIVE CUSTOMER FOLLOW-UP REPORT </title>');
             bodyhtml=bodyhtml.toString().replace("<font face = 'Arial' size = '4' color = '#FFFFF0'>MUKAYESELİ MÜŞTERİ TAKİP RAPORU</font>","<font face = 'Arial' size = '4' color = '#FFFFF0'>COMPARATIVE CUSTOMER FOLLOW-UP REPORT</font>")
             bodyhtml=bodyhtml.toString().replaceAll("Hesap Kodu","Airline Code")  
             bodyhtml=bodyhtml.toString().replaceAll("Hesap Adı","Account Name")  
             bodyhtml=bodyhtml.toString().replaceAll("Adet (İç)","Count (Dom.)")  
             bodyhtml=bodyhtml.toString().replaceAll("Count (İç)","Count (Dom.)") 
             
             bodyhtml=bodyhtml.toString().replaceAll("Adet (Dış)","Count (Int.)")  
             bodyhtml=bodyhtml.toString().replaceAll("Adet (Toplam)","Count (Total)")  
             bodyhtml=bodyhtml.toString().replaceAll("Gelir (İç)","Income (Dom.)")  
             bodyhtml=bodyhtml.toString().replaceAll("Gelir (Dis)","Income (Int.)") 
             bodyhtml=bodyhtml.toString().replaceAll("Gelir (Toplam)","Income (Total)") 
             bodyhtml=bodyhtml.toString().replaceAll("Gelir (Total)","Income (Total)") 
             bodyhtml=bodyhtml.toString().replaceAll("Ciro (İç)","Endorsement (Dom.)") 
             bodyhtml=bodyhtml.toString().replaceAll("Ciro (Dis)","Endorsement (Int.)")
             bodyhtml=bodyhtml.toString().replaceAll("Ciro (Toplam)","Endorsement (Total.)") 
             bodyhtml=bodyhtml.toString().replaceAll("Pay","Share")
             bodyhtml=bodyhtml.toString().replaceAll("Gelirleri göster;Ciroları göster;","Show Incomes;Show Endorsement")
             bodyhtml=bodyhtml.toString().replaceAll("Hesap Grupları :","Account Groups :")
             bodyhtml=bodyhtml.toString().replaceAll("Mukayese Dönem :","Comparative Period :") 
             bodyhtml=bodyhtml.toString().replaceAll("Masraf Merkezleri :","Cost Centers :")
             bodyhtml=bodyhtml.toString().replaceAll("TOPLAM :","TOTAL :") 
             
             	
             response.bodyText=bodyhtml;
          }
            var blob = new Blob([response.bodyText], {
              type: 'application/html'
            });
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = this.$t('CustomerFollowing') + ".html";
            link.click();


          }, (response) => {
            if (response.status === 0) {
              this.text1 = this.$t('Service-Unavailable')
              this.snackbar = true
              this.progress = false
              this.load1 = true
            } else {
              this.text1 = this.$t('Service-Unavailable')
              this.snackbar = true
              this.progress = false
              this.load1 = true
            }
          })
      } else {
        this.text1 = this.$t('start-date-cannot-greater-than-end-date')
        this.snackbar = true
      }
    }
  }


  function getListExcel() {
    if (this.$refs.formgunluksatis.validate()) {

      var bastarih = new Date(this.Rapor.BaslangicDonem)
      var bittarih = new Date(this.Rapor.BitisDonem)
      var onbastarih = new Date(this.Rapor.BaslangicOncekiDonem)
      var onbittarih = new Date(this.Rapor.BitisOncekiDonem)

      if (bastarih <= bittarih || onbastarih <= onbittarih) {

        this.progress = true
        this.load1 = false

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        var lang = localStorage.getItem('lang')
        if (this.tumsirketler === true) {
          this.Rapor.SirketKodu = '0'
        } else {
          this.Rapor.SirketKodu = credentials.SirketKodu
        }

        var params = this.Rapor

        this.$http
          .post(auth.API_URL + "api/TicketReport/CustomerPursuitReportExcel", params, {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader()
            },
            responseType: "arraybuffer"
          }).then((response) => {


            this.progress = false
            this.load1 = true
            if (lang=='en')
          {
            
             var bodyhtml=helpers.getTranslatedHtml(response.bodyText);
             bodyhtml=bodyhtml.toString().replace('<title> MUKAYESELİ MÜŞTERİ TAKİP RAPORU </title>','<title> COMPARATIVE CUSTOMER FOLLOW-UP REPORT </title>');
             bodyhtml=bodyhtml.toString().replace("<font face = 'Arial' size = '4' color = '#FFFFF0'>MUKAYESELİ MÜŞTERİ TAKİP RAPORU</font>","<font face = 'Arial' size = '4' color = '#FFFFF0'>COMPARATIVE CUSTOMER FOLLOW-UP REPORT</font>")
             bodyhtml=bodyhtml.toString().replace("Hava Yolu Code :","Airline Code :")
             bodyhtml=bodyhtml.toString().replace("Bilet No","Ticket No")
             bodyhtml=bodyhtml.toString().replace("Uçuş Tarihi","Flight Date")
             bodyhtml=bodyhtml.toString().replace("HY","AL")
             bodyhtml=bodyhtml.toString().replace("Uçuş No","Flight No")
             bodyhtml=bodyhtml.toString().replace("Yolcu Name","Passenger Name")
             bodyhtml=bodyhtml.toString().replace("Void Tarihi","Void Date")
             bodyhtml=bodyhtml.toString().replace("Satış Tarihi","Sales Date")
             bodyhtml=bodyhtml.toString().replace("Kesim Tarihi","Cutting Date")
             bodyhtml=bodyhtml.toString().replace("Bilet Amountı","Ticket Amount")
             bodyhtml=bodyhtml.toString().replace("Vergi Tutarı","Tax Amount")
             bodyhtml=bodyhtml.toString().replace("Discount Tutarı","Discount Amount")
             bodyhtml=bodyhtml.toString().replace("Saat","Hour")
             bodyhtml=bodyhtml.toString().replace("Parkur","Track")
             bodyhtml=bodyhtml.toString().replace("Varış Tarihi","Arrival Date")
             bodyhtml=bodyhtml.toString().replace("V.Saat","Arrival Hour")
             bodyhtml=bodyhtml.toString().replace("Müşteri","Customer")
             bodyhtml=bodyhtml.toString().replace("Acenta Kodu","Agency Code")
             
             response.bodyText=bodyhtml;
             
          }
            var blob = new Blob([response.data], {
              type: 'application/xlsx'
            });
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = this.$t('CustomerFollowing') + ".xlsx";
            link.click();


          }, (response) => {
            if (response.status === 0) {
              this.text1 = this.$t('Service-Unavailable')
              this.snackbar = true
              this.progress = false
              this.load1 = true
            } else {
              this.text1 = this.$t('Service-Unavailable')
              this.snackbar = true
              this.progress = false
              this.load1 = true
            }
          })
      } else {
        this.text1 = this.$t('start-date-cannot-greater-than-end-date')
        this.snackbar = true
      }
    }
  }


  function beforeMount() {



  }
</script>
<style scoped>
</style>